import MuiIconButton from '@mui/material/IconButton';
import patchButtonBaseComponent from './patch-base-button-components';
export const IconButton = patchButtonBaseComponent(MuiIconButton);
